/* eslint-disable no-continue */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
import { axiosAPIInstance as axios } from '../../axios-config';

const state = {
  loaded: false,
  environments: [],
  manifests: new Map(),
  enabled: new Map(),
  _manifestSwitch: false
};

function saveEnabledList(enabled) {
  const saveData = [];
  for (const en of enabled.keys()) {
    saveData.push(en);
  }
  window.localStorage.setItem('assetEnabledSettings', JSON.stringify(saveData));
}

const mutations = {
  setAssetEnvironments(state, data) {
    state.environments = data;
  },
  setAssetManifest(state, { environment, data }) {
    state.manifests.set(environment, data);
    state._manifestSwitch = !state._manifestSwitch;
  },
  setAssetManifestEnabled(state, { environment, enabled }) {
    state.enabled.set(environment, enabled);
    saveEnabledList(state.enabled);
    state._manifestSwitch = !state._manifestSwitch;
  },
  setAssetManifestEnabledListFromNameList(state, nameList) {
    state.enabled.clear();
    for (const key of nameList) {
      state.enabled.set(key, true);
    }

    saveEnabledList(state.enabled);
    state._manifestSwitch = !state._manifestSwitch;
  },
  setAssetSystemLoaded(state, loaded) {
    state.loaded = loaded;
  }
};

const actions = {
  async loadAssetData({ commit }) {
    if (this.loaded) return;
    commit('setAssetManifestEnabledListFromNameList', JSON.parse(window.localStorage.getItem('assetEnabledSettings') || '["master"]'));
    try {
      const envReq = await axios.get(`https://assets.redmeru.com/environments.json?nocache=${Date.now()}`, {
        headers: {},
        ignoreAdditionalHeaders: true
      });

      const environments = envReq.data;

      // eslint-disable-next-line no-restricted-syntax
      for (let i = 0; i < environments.length; ++i) {
        const env = environments[i];
        try {
          const manReq = await axios.get(`https://assets.redmeru.com/${env}/manifest.json?nocache=${Date.now()}`, {
            headers: {},
            ignoreAdditionalHeaders: true
          });

          const parsed = manReq.data;
          parsed.enabled = false;
          commit('setAssetManifest', { environment: env, data: parsed });
        } catch (er) {
          console.error(`Failed to load environment manifest ${env}`);
          environments.splice(i);
          // eslint-disable-next-line no-plusplus
          --i;
        }
      }
      commit('setAssetEnvironments', environments);
    } catch (er) {
      console.error(er);
    }
    commit('setAssetSystemLoaded', true);
  }
};

function aggregateDirectoryTreeNode(state, path) {
  const node = {
    Directories: [],
    Files: []
  };

  const pathSplit = path === '' ? [] : path.split('/');
  for (const k of state.enabled.keys()) {
    const manifest = state.manifests.get(k);
    if (!manifest) continue;

    let cur = manifest.Root;
    for (let i = 0; i < pathSplit.length; ++i) {
      const part = pathSplit[i];
      console.log(`trying ${part}`);
      if (cur.Directories[part]) {
        console.log('found');
        cur = cur.Directories[part];
      } else {
        cur = null;
        break;
      }
    }

    if (cur) {
      const dirs = Object.keys(cur.Directories);
      for (const dir of dirs) {
        if (!node.Directories.includes(dir)) {
          node.Directories.push(dir);
        }
      }

      const files = Object.keys(cur.Files);
      for (const file of files) {
        node.Files.push(Object.assign({ local: file, env: k }, cur.Files[file]));
      }
    } else { continue; }
  }

  node.Files.sort((a, b) => a.local.localeCompare(b.local));
  for (let i = 1; i < node.Files.length; ++i) {
    const a = node.Files[i - 1];
    const b = node.Files[i];

    if (a.local === b.local) {
      a.showEnv = true;
      b.showEnv = true;
    }
  }

  return node;
}

const getters = {
  getAssetEnvironments(state) {
    return state.environments;
  },
  getAssetManifest(state) {
    if (state._manifestSwitch && !state._manifestSwitch) { console.log('impossible'); }
    return env => state.manifests.get(env);
  },
  getEnabledAssetManifests(state) {
    if (state._manifestSwitch && !state._manifestSwitch) { console.log('impossible'); }
    const arr = [];
    for (const k of state.enabled.keys()) { arr.push(k); }
    if (arr.length === 0) arr.push('master');
    return arr;
  },

  isAssetManifestEnabled(state) {
    if (state._manifestSwitch && !state._manifestSwitch) { console.log('impossible'); }
    return env => state.enabled.get(env) || false;
  },
  listAssetsAtPath(state) {
    if (state._manifestSwitch && !state._manifestSwitch) { console.log('impossible'); }

    return (path) => {
      const node = aggregateDirectoryTreeNode(state, path);
      return node.Files;
    };
  },
  listDirectoriesAtPath(state) {
    if (state._manifestSwitch && !state._manifestSwitch) { console.log('impossible'); }

    return (path) => {
      const node = aggregateDirectoryTreeNode(state, path);
      const res = [];
      for (const k of node.Directories) {
        res.push(k);
      }
      return res;
    };
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/blade/assets.js